
import { Options, Vue } from 'vue-class-component';
import { CompanyClient, RawMaterialCompanyConversionClient } from '@/services/Services';
import editMaterialNameAndGramsModal from '../modals/editMaterialNameAndGramsModal.vue';
import InfoModal from '@/components/modals/infoModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class CompanyMaterials extends Vue {

    companyId: string = "";
    company: OM.Company = null;

    tabs = [
        { type: OM.MaterialType.Apparel, label: "Apparel" },
        { type: OM.MaterialType.Footwear, label: "Footwear" },
        { type: OM.MaterialType.Bag, label: "Bag" },
        { type: OM.MaterialType.Fabric, label: "Fabric" },
    ];

    activeTab: OM.MaterialType = OM.MaterialType.Apparel;

    itemsByType: { [key: number]: OM.CompanyMaterialConversionVM[] } = {
        [OM.MaterialType.Apparel]: [],
        [OM.MaterialType.Footwear]: [],
        [OM.MaterialType.Bag]: [],
        [OM.MaterialType.Fabric]: [],
    };

    created() {
        this.companyId = this.$route.params.identifier as string;
        this.init();
    }

    init() {
        // ONE call. GetOrCreateCopiesByEdmondsMaterialForCompany CREATES the company's missing conversion
        // rows as a side effect — it is a check-then-insert. Fetching one tab at a time would mean four
        // concurrent calls, two of which could both find a row missing and both create it.
        Promise.all([
            CompanyClient.getById(this.companyId),
            RawMaterialCompanyConversionClient.getOrCreateCopiesByEdmondsMaterialForCompany(this.companyId)
        ])
        .then(xs => {
            this.company = xs[0];

            var partitioned: { [key: number]: OM.CompanyMaterialConversionVM[] } = {
                [OM.MaterialType.Apparel]: [],
                [OM.MaterialType.Footwear]: [],
                [OM.MaterialType.Bag]: [],
                [OM.MaterialType.Fabric]: [],
            };

            xs[1].forEach(item => {
                partitioned[item.materialType].push(item);
            });

            this.itemsByType = partitioned;
        })
        .catch(y => {
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: this.$localizationService.getLocalizedValue(
                    "The company's materials could not be loaded.",
                    "The company's materials could not be loaded."),
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => {
                    this.$opModal.closeLast();
                }
            })
        })
    }

    editMaterialNameAndGrams(modelItem: OM.CompanyMaterialConversionVM) {
        this.$opModal.show(editMaterialNameAndGramsModal, {
            model: modelItem,
            callback: (editVM: OM.RawMaterialCompanyConversionVM) => {
                RawMaterialCompanyConversionClient.updateNameAndGramsForCompany(editVM)
                .then(x => {
                    this.$opModal.closeLast();
                    this.init();
                })
            }
        })
    }
}
